module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_68.650c0b16.png";